import styled from "styled-components";

const CardSquares = styled.div`
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction: column;
    
    /* border: 1px solid var(--border-color); */
    border-radius: 2px;
    
    >span.value{
        font-weight: bold;
        font-size: 24px;
        color: var(--default-color-font);       
    }

    >span.text{
        text-align: center;
        color: var(--grey-light);
        font-weight: bold;
        text-transform: uppercase;
        font-size: 12px;
        margin-bottom: 0.5rem;
    }
`;

export default CardSquares;
